import styled from 'styled-components'

export default styled.section`
  width: 100%;
  background-color: ${ ({ theme }) => theme.colors.white };
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 24px 30px;
  gap: 16px;

  &.empty {
    opacity: 0.85;
  }

  > header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;

    h4 {
      margin: 0;
    }

    .delete {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 4px;
      display: flex;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .summary {
      margin: 0;
      color: ${ ({ theme }) => theme.colors.greyDark };
      font-size: 14px;
    }
  }

  > footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
`
